var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBigPic = function SvgBigPic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.538 8.615a1.85 1.85 0 0 1 1.847 1.847v3.692A1.848 1.848 0 0 1 5.538 16H1.846A1.848 1.848 0 0 1 0 14.154v-3.692c0-1.018.828-1.847 1.846-1.847h3.692Zm0 1.231H1.846a.616.616 0 0 0-.615.616v3.692c0 .34.276.615.615.615h3.692c.34 0 .616-.275.616-.615v-3.692a.616.616 0 0 0-.616-.616Zm9.847 3.077a.615.615 0 1 1 0 1.23H9.846a.615.615 0 1 1 0-1.23h5.539Zm0-3.077a.615.615 0 1 1 0 1.23H9.846a.615.615 0 1 1 0-1.23h5.539ZM5.538 0c1.018 0 1.847.828 1.847 1.846v3.692a1.848 1.848 0 0 1-1.847 1.847H1.846A1.848 1.848 0 0 1 0 5.538V1.846C0 .828.828 0 1.846 0h3.692Zm9.847 4.923a.615.615 0 1 1 0 1.23H9.846a.615.615 0 1 1 0-1.23h5.539ZM5.538 1.231H1.846a.616.616 0 0 0-.615.615v3.692c0 .34.276.616.615.616h3.692c.34 0 .616-.276.616-.616V1.846a.616.616 0 0 0-.616-.615Zm9.847.615a.615.615 0 1 1 0 1.23H9.846a.615.615 0 1 1 0-1.23h5.539Z",
    fill: "#333"
  })));
};

export default SvgBigPic;